import { Box } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { AdminSensorType, DeviceModel, SelectOption } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import Spinner from "../../../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/Tabs/Tabs";
import ModelSettingsTab from "./tabs/ModelSettingsTab";

const ModelItem = () => {
  const { id } = useParams();

  const [models, setModels, sensors] = useOutletContext<[DeviceModel[], Function, SelectOption[]]>();
  const [currentModel, setCurrentModel] = useState<DeviceModel>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      return;
    }
    if (!models) {
      navigate("/admin/models");
      return;
    }
    setLoading(true);
    setCurrentModel(models.find((model) => model.id == id));
  }, [id]);

  useEffect(() => {
    if (!currentModel) {
      return;
    }
    setLoading(false);
  }, [currentModel]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <Tabs defaultValue="settings" className="w-full h-full">
        <TabsList className="flex-none flex w-full h-12 bg-background">
          <div className="flex w-full max-w-[900px] justify-start mx-auto pl-4 pr-16">
            <TabsTrigger className="data-[state=active]:bg-muted data-[state=active]:text-foreground" value="settings">
              {t("settings")}
            </TabsTrigger>
          </div>
        </TabsList>
        <Separator />
        <ScrollArea>
          <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden mb-20">
            <TabsContent value="settings">
              <ModelSettingsTab id={id} currentModel={currentModel} sensors={sensors!} />
            </TabsContent>
          </div>
        </ScrollArea>
      </Tabs>
    </>
  );
};

export default ModelItem;
